<app-left-side-nav></app-left-side-nav>
<app-header></app-header>
  <!-- page content area start-->
    <div class="afterLoginPageContainer">
  <div class="mainContent">
    <div class="inviteList p-3">
      <div class="backLink" *ngIf="(inviteList?.length || 0) > 0;">
        You have {{ inviteList.length }} invitation{{ inviteList.length > 1 ? 's' : '' }} pending
      </div>
      <p *ngIf="(inviteList?.length || 0) > 0">Accept invitations to get Tickets </p>

      <div class="list mt-4" *ngIf="inviteList?.length">
        <div class="invite p-3 mb-3" *ngFor="let inv of inviteList; trackBy: trackById">
          <div class="d-flex align-items-center">
            <div class="userlogo">
              <img
                [src]="inv.invited_by_image_smallthumb_url || 'assets/images/default-profile-individual.png'"
                class="rounded-circle"
                (error)="onImgError($event)"
                alt="inviter logo"
              />
            </div>
            <div class="info ms-3">
              <p class="mb-0 font-weight-600">Invitation From</p>
              <h5 class="font-weight-600 mb-0">
                {{ inv.invited_by_organisation_name || 'Unknown' }}
              </h5>
             
            </div>
          </div>

          <div class="tktInfo mt-3">
            <h5 class="green font-weight-600">
              {{ inv.entry_type | titlecase }} Entry
<img class="ms-1 ticket-icon" [src]="inv.ticket_icon_url" alt="ticket type" />
            </h5>
            <p>{{ inv.ticket_note }}</p>
          </div>

          <div>
            <button class="btn" (click)="navigateToInviteDetails(inv.encoded_invite_code)">View Invitation</button>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>
